var _rect, _rect2, _rect3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 13,
    height: 1,
    rx: 0.5,
    fill: "#91979E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13.5,
    width: 13,
    height: 1,
    rx: 0.5,
    fill: "#91979E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8.5,
    width: 13,
    height: 1,
    rx: 0.5,
    fill: "#91979E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 4,
    r: 1,
    fill: "#91979E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 1,
    fill: "#91979E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 9,
    r: 1,
    fill: "#91979E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b7ac7ced7cdaffc9bcdeeb08f3193609.svg";
export { ForwardRef as ReactComponent };